import React, { useContext, useEffect, useState } from 'react'
import { ShopContext } from '../context/ShopContext'
import Title from './Title';
import ProductCard from './ProductCard';

const LatestCollection = () => {

    const { products,reviews } = useContext(ShopContext);
    const [latestProducts,setLatestProducts] = useState([]);
  const getAverageRating = (productId) => {
    const productReviews = reviews.filter((review) => review.productId === productId);
    if (productReviews.length === 0) return 0;
    const sum = productReviews.reduce((acc, review) => acc + review.rating, 0);
    return sum / productReviews.length;
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
    }).format(price);
  };
    
    useEffect(()=>{
        setLatestProducts(products.slice(0,10))
    },[products])

  return (
    <div className='my-10'>
      <div className="text-center py-8 text-3xl">
        <Title text1={'LATEST'} text2={'COLLECTION'}/>
        <p className='w-3/4 m-auto text-xs sm:text-sm md:text-base text-gray-600'>
        Introducing our latest collection of curtains, where style meets functionality. This season, we bring you a curated selection of high-quality fabrics, contemporary designs, and innovative features that elevate your home décor.</p>

      </div>

    {/* Rendering Products */}

    <div className='grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 gap-y-6'>
    {
        latestProducts.map((product,index)=>(
            <ProductCard
                  key={product._id}
                  product={product}
                  formatPrice={formatPrice}
                  getAverageRating={getAverageRating}
                  reviews={reviews}
                />
        ))
    }
    </div>

    </div>
  )
}

export default LatestCollection
